import { render } from "./user-balance-callback.vue?vue&type=template&id=d424761a"
import script from "./user-balance-callback.vue?vue&type=script&lang=js"
export * from "./user-balance-callback.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__